/* tslint:disable */

declare var Object: any;
export interface TeodempsurveyInterface {
  "empId": string;
  "surveyCode": string;
  "companyCode": string;
  "surveyDate"?: Date;
  "completed"?: number;
  "createdBy"?: string;
  "createdDate"?: Date;
  "modifiedBy"?: string;
  "modifiedDate"?: Date;
}

export class Teodempsurvey implements TeodempsurveyInterface {
  "empId": string;
  "surveyCode": string;
  "companyCode": string;
  "surveyDate": Date;
  "completed": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  constructor(data?: TeodempsurveyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teodempsurvey`.
   */
  public static getModelName() {
    return "Teodempsurvey";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teodempsurvey for dynamic purposes.
  **/
  public static factory(data: TeodempsurveyInterface): Teodempsurvey{
    return new Teodempsurvey(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teodempsurvey',
      plural: 'Teodempsurveys',
      path: 'Teodempsurveys',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "surveyCode": {
          name: 'surveyCode',
          type: 'string'
        },
        "companyCode": {
          name: 'companyCode',
          type: 'string'
        },
        "surveyDate": {
          name: 'surveyDate',
          type: 'Date'
        },
        "completed": {
          name: 'completed',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teodempsurvey.ts